<template>
  <div class="ibox-content">
    <div class="row table-responsive">
      <div style="font-size: 24px; font-weight: 500; margin-bottom: 27px">
        Confirmed Events
      </div>
      <div class="search-wrap">
        <div class="search-item">
          <label class="col-sm-2 control-label"> Event Title </label>
          <div class="col-sm-4">
            <el-input
              v-model="confirmedSearchParams.searchName"
              clearable
            ></el-input>
          </div>
          <div class="btn-wrap" v-if="userRole != 0">
            <el-button @click="getConfirmedList()" type="primary">{{
              $t("message.Search")
            }}</el-button>
          </div>
        </div>
        <div class="search-item" v-if="userRole == 0">
          <label class="col-sm-2 control-label"> District </label>
          <div class="col-sm-4">
            <el-select
              v-model="confirmedSearchParams.districtCode"
              v-bind:placeholder="$t('message.PleaseSelect')"
              name="eventDistrictCode"
              clearable 
              filterable
            >
              <el-option
                v-for="item in districtGetlist"
                :key="item.districtCode"
                :label="item.districtNameEn"
                :value="item.districtCode"
              >
              </el-option>
            </el-select>
          </div>
          <div class="btn-wrap">
            <el-button @click="getConfirmedList()" type="primary">{{
              $t("message.Search")
            }}</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="row table-responsive">
      <div class="col-xs-12 add-btn">
        <el-button @click="handleArchiveEvent">{{
          archive ? "Unarchive" : "Archive"
        }}</el-button>
        <el-button

          v-if="!archive && checkPermission('SchoolEvent_LIST_ADD')"
          @click="handleNavToConfirmedDetail"
          icon="el-icon-plus"
          type="primary"
          >Add</el-button
        >
      </div>
    </div>
    <div class="row table-responsive" style="padding-bottom: 60px">
      <div class="col-xs-12">
        {{ confirmedTotal }}{{ $t("message.datagridresult") }}
      </div>
      <el-table
        :data="confirmedList"
        style="width: 100%"
        ref="multipleTable"
        :fit="true"
        border
        class="rowss"
        row-key="id"
        :cell-class-name="cell"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          label="Event title"
          prop="eventTitle"
          sortable
          min-width="200"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
              <div>
                <el-tag
                  type="warning"
                  effect="dark"
                  size="mini"
                  v-if="scope.row.expired"
                >
                  Expired
                </el-tag>
                {{ scope.row.eventTitle }}
              </div>
            </template>
        </el-table-column>
        <el-table-column
          prop="districtName"
          label="Event District"
        ></el-table-column>
        <el-table-column
          label="IDEAS category"
          prop="ideasCategory"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="Event Date"
          prop="startEventDate"
          sortable
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column label="Last update time" :show-overflow-tooltip="true">
          <template slot-scope="scope">
           {{$dayjs(scope.row.updatedAt).format("YYYY-MM-DD HH:mm:ss")}}
          </template>
        </el-table-column>
        <el-table-column
          label="Status"
          prop="status"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            {{ statusMap[scope.row.status] }}
          </template>
        </el-table-column>
        <el-table-column label="Action" width="150" fixed="right">
          <template slot-scope="scope">
            <div
              :style="{
                display: 'flex',
                'justify-content': scope.row.status == 1 ? 'space-between' : '',
              }"
            >
              <el-button
                style="max-width: 50px"
                @click="handleNavToConfirmedDetail(scope.row)"
                size="mini"
                ><i class="el-icon-edit"></i
              ></el-button>
              <el-popconfirm
                title="Are you sure you want to cancel the event?"
                confirmButtonText="Yes"
                cancelButtonText="No"
                @confirm="handleCancelEvent(scope.row.id)"
                v-if="scope.row.status == 2"
              >
                <el-button
                  style="max-width: 70px; margin-left: 10px"
                  type="primary"
                  size="mini"
                  slot="reference"
                  >Cancel</el-button
                >
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-col :span="24" class="el-table_footertoolbar">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleConfirmedSizeChange"
          @current-change="handleConfirmedCurrentChange"
          :page-sizes="[10, 20, 50, 100, 200]"
          :page-size="confirmedSearchParams.pageSize"
          :total="confirmedTotal"
          style="float: right"
        >
        </el-pagination>
      </el-col>
    </div>
  </div>
</template>
<script>
import config from "@/config";
import axios from "axios";
import Sortable from "sortablejs";

export default {
  mixins: [config.globalMixin],
  components: {},
  props: {
    archive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      confirmedSearchParams: {
        pageSize: 10,
        pageIndex: 1,
        sortName: "",
        sortType: "",
        searchName: "",
        districtCode: "",
        sourceType: 2,
      },
      confirmedList: [],
      confirmedTotal: 0,
      multipleSelection: [],
      districtGetlist: [],
      canDrag:false
    };
  },
  computed: {
    baseURL() {
      return config.domain + "/";
    },
    userInfo() {
      return this.getAuthObj();
    },
    statusMap() {
      return {
        2: "Confirmed",
        3: "Cancelled",
      };
    },
    userRole() {
      const res = JSON.parse(sessionStorage.getItem("userInfo"));
      return res.roleType;
    },
  },
  created: function () {
    if (this.checkPermission("SchoolEvent_LIST_ORDER")) {
      this.canDrag = true;
    }
  },
  mounted() {
    if(this.userRole==0) this.confirmedSearchParams.districtCode = JSON.parse(sessionStorage.getItem("userInfo")).userDistrictCode
    this.intiPage();
  },
  methods: {
    cell: function ({ row }) {
      if (!this.canDrag) {
        return "disabled pointer";
      }
      // if (row.status == 1) {
      return "cursor-move";
      // } else {
      //   return "disabled pointer";
      // }
    },
    intiPage() {
      this.getConfirmedList();
      this.getDistrictGetlist();
      const table = document.querySelector(
        ".rowss .el-table__body-wrapper tbody"
      );
      const self = this;
      Sortable.create(table, {
        onEnd({ newIndex, oldIndex }) {
          self.updateConfirmedListSort(newIndex, oldIndex);
        },
        filter: ".disabled",
        onMove: (event) => {
          return !event.related.classList.contains("disabled");
        },
      });
    },
    async getDistrictGetlist() {
      let obj = this.getAuthObj();
      obj.apiUrl = this.apiConfig.districtGetlist;
      let data = await this.$store.dispatch("apiEvent", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.$set(this, "districtGetlist", data.data.result);
    },
    async updateConfirmedListSort(newIndex, oldIndex) {
      const item = this.confirmedList[oldIndex];
      this.confirmedList.splice(oldIndex, 1);
      this.confirmedList.splice(newIndex, 0, item);
      const lstOrderDTO = this.confirmedList.map((i) => {
        return {
          id: i.eventId,
          displayOrder: i.sortOrder,
        };
      });
      const param = {
        lstOrderDTO,
        ...this.userInfo,
      };
      const {
        data: { status_code, status_message },
      } = await axios.post(this.baseURL + "schoolEvent/order", {
        ...param,
      });
      if (status_code == "0") {
        this.getConfirmedList();
      } else if (status_code == "000104") {
        this.timeoutEvent();
        return;
      } else {
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }
    },
    async getConfirmedList(isGoFristPage) {
      if (isGoFristPage) this.confirmedSearchParams.pageIndex = 1;
      let searchParam = this.getAuthObj();
      searchParam = {
        ...searchParam,
        ...this.confirmedSearchParams,
        archivedStatus: this.archive ? 1 : 0,
        apiUrl: "/schoolEventRequest/getSchoolEventRequests",
      };
      let data = await this.$store.dispatch("apiEvent", searchParam);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.confirmedList = data.data.result.schoolRequest;
      this.confirmedTotal = data.data.result.total;
    },
    handleConfirmedSizeChange(val) {
      this.confirmedSearchParams.pageSize = val;
      this.getConfirmedList("goFristPage");
    },
    handleConfirmedCurrentChange(val) {
      this.confirmedSearchParams.pageIndex = val;
      this.getConfirmedList();
    },
    handleNavToConfirmedDetail(row) {
      this.$router.push({
        path: "/main/confirmedEventDetail",
        query: {
          id: row.id,
        },
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val.map((i) => {
        return i.eventId;
      });
    },
    async handleCancelEvent(id) {
      let searchParam = this.getAuthObj();
      searchParam = {
        ...searchParam,
        status: 3,
        id: id,
        apiUrl: "/schoolEventRequest/updateStatus",
      };
      let data = await this.$store.dispatch("apiEvent", searchParam);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.getConfirmedList();
    },
    async handleArchiveEvent() {
      const param = {
        lstSchoolEventId: this.multipleSelection,
        status: this.archive ? 0 : 1,
        ...this.userInfo,
      };
      const {
        data: { status_code, status_message },
      } = await axios.post(
        this.baseURL + "schoolEvent/updateArchivedStatus",
        param
      );
      if (status_code == "0") {
        this.getConfirmedList();
      } else {
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.add-btn {
  display: flex;
  justify-content: flex-end;
}
.search-wrap {
  display: flex;
  flex-direction: column;
  .search-item {
    margin-bottom: 15px;
    display: flex;
    .entry-no-wrap {
      display: flex;
      .separator {
        margin: 0 10px;
        display: flex;
        align-items: center;
      }
    }
    .btn-wrap {
      display: flex;
      justify-self: flex-end;
    }
  }
}
</style>